

























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {Station} from "@/models/station";
import {Machine} from "@/models/machine";
import moment from "moment";
import { RepositoryFactory } from '@/api/RepositoryFactory';

const StationStore = namespace('station');
const MachineStore = namespace('machine');

@Component({})
export default class EditMachineComponent extends Vue {

  @StationStore.Getter('selectedStation')
  public station!: Station;

  @MachineStore.Action("createMachine")
  public createMachine!:(payload: { station: Station, machine: Machine }) => Promise<Machine>

  @MachineStore.Action("updateMachine")
  public updateMachine!:(payload: { machine: Machine }) => Promise<Machine>

  @Prop({ default: () => new Machine({}) })
  public machine!: Machine;


  public menu: boolean = false;
  public nextMaintenanceMenu: boolean = false;
  public actuatorItems = [];
  public actuatorOptions = [{ text: "NEU", value: "NEW" }, { text: "ALT", value: "OLD" }];

  public valid: boolean = false;

  machineRules(type: string) {
    return [
      (v: any) => !!v || `${type} ist erforderlich`
    ]
  }

  InspectionRules(type: string) {
    return [
      (v: any) => !!v || `${type} ist erforderlich`
    ]
  }

  public async mounted() {
    const actuatorTypeRepository = RepositoryFactory.get('actuatorType');
    const actuatorTypes = await actuatorTypeRepository.getAllActuatorTypes();
    this.actuatorItems = actuatorTypes.data.map((item: any) => item);

    if (!this.machine.id) {
      this.machine.maintenanceActive = this.station.maintenanceActive;
      if (this.station.nextMaintenance) {
        this.machine.nextMaintenance = this.station.nextMaintenance;
        this.machine.nextMaintenanceDate = this.station.nextMaintenanceDate;
      }
    }
    this.setEditableItem()
  }

  public setEditableItem() {
    this.editedItem.id = (this.machine.id) ? this.machine.id : '';
    this.editedItem.orderNo = this.machine.orderNo;
    this.editedItem.serialNo = this.machine.serialNo;
    this.editedItem.tagNo = this.machine.tagNo;
    this.editedItem.actuatorUnit = this.machine.actuatorUnit;
    this.editedItem.actuator = this.resolveActuatorValue(this.machine.actuator);
    this.editedItem.actuatorOption = this.machine.actuatorOption;
    this.editedItem.lastMaintenance = this.machine.lastMaintenance;
    this.editedItem.nextMaintenance = this.machine.nextMaintenance;
    this.editedItem.inspectionYears = this.machine.inspectionYears;
    this.editedItem.inspectionInterval = this.machine.inspectionInterval;
    this.editedItem.maintenanceActive = this.machine.maintenanceActive;
    this.editedItem.location = this.machine.location ?? '';
  }

  public reverseEditableItem(arg?: string) {
    if(!arg) {
      this.machine.inspectionYears = this.editedItem.inspectionYears;
    }
    this.machine.orderNo = this.editedItem.orderNo;
    this.machine.serialNo = this.editedItem.serialNo;
    this.machine.tagNo = this.editedItem.tagNo;
    this.machine.actuatorUnit = this.editedItem.actuatorUnit;
    this.machine.location = this.editedItem.location;
    this.machine.actuator = this.editedItem.actuator;
    this.machine.actuatorOption = this.editedItem.actuatorOption;
    this.machine.lastMaintenance = this.editedItem.lastMaintenance;
    this.machine.nextMaintenance = this.editedItem.nextMaintenance;
    this.machine.inspectionInterval = this.editedItem.inspectionInterval;
    this.machine.maintenanceActive = this.editedItem.maintenanceActive;
  }

  public editedItem = {
    id: '',
    orderNo: '',
    serialNo: '',
    tagNo: '',
    actuatorUnit: '',
    actuator: '',
    location: '',
    actuatorOption: '',
    lastMaintenance: '',
    nextMaintenance: '',
    inspectionYears: 0,
    inspectionInterval: 0,
    maintenanceActive: false,
  }


  public closeDialog() {
    this.$emit('closeDialog', false);
  }

  public async saveMachine() {
    if (this.machine.id) {
      this.reverseEditableItem();
      await this.updateMachine({ machine: this.machine });
    } else {
      this.machine.inspectionYears = Number(this.editedItem.inspectionYears);
      this.reverseEditableItem('inspectionYears');
      await this.createMachine({ station: this.station, machine: this.machine });
    }
    this.$emit('closeDialog', true);
  }

  public formattedDate(dateString: string) {
    if (!dateString) return null;
    return moment(dateString).format('DD.MM.YYYY');
  }

  /**
   * v-select nutzt item-value="lowerCaseName", Maschinen speichern teils name statt lowerCaseName.
   */
  private resolveActuatorValue(storedActuator: string): string {
    if (!storedActuator) return '';
    const normalized = storedActuator.toLowerCase();
    const found = (this.actuatorItems as Array<{ name: string; lowerCaseName: string }>).find(
      (a) =>
        a.lowerCaseName === storedActuator ||
        a.lowerCaseName === normalized ||
        a.name === storedActuator ||
        a.name?.toLowerCase() === normalized
    );
    return found ? found.lowerCaseName : normalized;
  }
}

